"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioItem = void 0;
const react_1 = __importDefault(require("react"));
const radio_1 = require("../../../helpers/radio");
const Label_1 = require("../../atoms/Label/Label");
const Radio_1 = require("../../atoms/Radio/Radio");
const RadioItem = ({ value, onChange, group, groupValue, id, ...remainingRadioProps }) => {
    const { value: valueName, label, textBelowLabel, bonusText } = (0, radio_1.getRadioItemData)(value);
    const htmlId = id || `${group}-${valueName}`;
    return (react_1.default.createElement("div", { className: "flex items-start gap-4" },
        react_1.default.createElement(Radio_1.Radio, { value: valueName, group: group, checked: valueName === groupValue, onChange: onChange, id: htmlId, ...remainingRadioProps }),
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement(Label_1.Label, { id: htmlId, size: "lg" }, label),
            textBelowLabel && (react_1.default.createElement("label", { className: "cursor-pointer text-xs", htmlFor: htmlId }, textBelowLabel)),
            bonusText && react_1.default.createElement("label", { className: "pt-1 text-xs font-bold tracking-wide text-red-5" }, bonusText))));
};
exports.RadioItem = RadioItem;
